// extracted by mini-css-extract-plugin
export default {"title":"BirthdayKidsList_title__0NK8K","list":"BirthdayKidsList_list__lq5p6"};